<template>
  
  <div id="forecast-map"> <!--<div id="forecast-map" v-bind:key="selected">だとroute変更時にmapにもhover入る -->
    <transition appear name="map-el">
    <div id="map" class="map-jp" :class="selected"  v-show="loaded">
      <ul>
        <li class="map-title">
          <p>夕焼け予報 {{date}}</p>
        </li>
        <!-- <li><p><router-link to="/about">一時期停止していましたが、今度こそ復旧しました！(2020年11月)</router-link></p></li> -->
        <li v-for="place in places" class="point" :class="{selected: place.selected}" :style="place.style" :key="place.name">
          <router-link :to="`/places/${ place.name }`" class="has-text-grey-dark">
        
            <dl>
              <dt class="name">{{place.kanji}}</dt>
              <dd>
                <span v-if="place.image === 1"><img src="@/assets/images/slice1.png" width="35rem"/></span>
                <span v-if="place.image === 2"><img src="@/assets/images/slice2.png" width="35rem"/></span>
                <span v-if="place.image === 3"><img src="@/assets/images/slice3.png" width="35rem"/></span>
                <dl class="forecast">{{place.forecast}}</dl>
                <p class="precip">{{place.per}}%</p>
              </dd>
            </dl>
          </router-link>
          <ul class="menu-pref">
          </ul>
        </li>
      </ul>
      <img src="@/assets/images/map-jp.png" @load="load" class="">
    </div>
    </transition>
  </div>

</template>



<script>
import predictMapper from "@/components/predictMapper"
export default {
  data () {
    return {
      places: [
        {name: "Tokyo", kanji: "東京", forecast: "", image: "", selected:false, style:{left: '63.0%', top: '53.0%'}},
        {name: "Nagoya", kanji: "名古屋", forecast:"", image: "", selected:false, style:{left: '42.0%', top: '69.0%',padding: '8px 8px'}},
        {name: "Osaka", kanji: "大阪", forecast:"", image: "", selected:false, style:{left: '30.0%', top: '40.0%'}}
      ],
      date: " / ()",
      selected: "Tokyo",
      loaded: false
    }
  },  
  updated(){
    this.places.forEach((place)=>{
      if(place.name == this.selected){
        place.selected = true
      }else{
        place.selected = false
      }
    })
  },
  methods: {
    load(){
      this.loaded = true
    }
  },
  mounted () {
    const forecastData = require("../assets/js/forecasts.json")
    const now = new Date()
    if(this.$route.params.place !== undefined){
        this.selected = this.$route.params.place
    }
    const weekAssign = ["日","月","火","水","木","金","土"]
    const weekday = weekAssign[now.getDay()]
    this.date = `${now.getMonth()+1}/${now.getDate()}(${weekday})`

    this.places.forEach((place)=>{
      const updatedForecast = forecastData.filter((fc)=>{
        return fc.place == place.name
      }).filter((fc)=>{
        const predictTime = new Date(fc.predictTime)
        const predictDay = Math.floor((predictTime.getTime()+1000*60*60*9)/1000/60/60/24) //JST扱い
        const nowDay = Math.floor((now.getTime()+1000*60*60*9)/1000/60/60/24) // JST扱い
        const deltaTime =  predictDay - nowDay
        return deltaTime == 0 // 同じ日を取り出し
      }).sort((fc_a,fc_b)=>{
        const fc_a_gribtime = new Date(fc_a.updated)
        const fc_b_gribtime = new Date(fc_b.updated)
        return fc_b_gribtime.getTime() - fc_a_gribtime.getTime() // 最終更新で並び替え
      })
      if(updatedForecast[0] == null){
        return
      }
      const predict = predictMapper(updatedForecast[0].predicts)
      place.forecast = predict.text
      place.per = predict.per
      place.image = predict.image
    })

    
  },
  watch: {
    '$route' (to,from){
      if(this.$route.params.place !== undefined){
        this.selected = this.$route.params.place
      }
    }
  }
}
</script>


<style>
li.map-title{
  left: 3%;
  top: 7%;
  text-align: center;
  position: absolute;
}
li.map-title p{
  position: relative;
  z-index: 1;
  padding: 8px 8px;
  color: rgb(130,130,130);
  font-size: 18px;
}

li p.notice{
  position: relative;
  display: block;
  z-index: 1;
  padding: 8px 10px;
  border: solid 1px rgb(200,200,200);
  border-radius: 3px;
  background-color: rgba(255,255,255);
  box-shadow: 0 2px 5px rgba(52,50,52,0.2);
  line-height: 1;
  font-size: 15px;
}

#map{
  position: relative;
}

#map .point {
  text-align: center;
  position: absolute;
}

#map li.selected a{
  border: solid 2px rgb(255,180,140);
}

#map li a {
  position: relative;
  display: block;
  z-index: 1;
  padding: 8px 10px;
  border: solid 1px rgb(200,200,200);
  border-radius: 3px;
  background-color: rgba(255,255,255);
  box-shadow: 0 2px 5px rgba(52,50,52,0.2);
  line-height: 1;
  font-size: 15px;
}


.map-el-enter-active{
  transition: all 1.1s .2s;
}
.map-el-leave-active{
  transition: all .3s .0s;
}
.map-el-enter, .map-el-leave-to{
  opacity: 0;
}

@media screen and (max-width: 550px) {
  #map li a {
    padding: 4px 5px;
    font-size: 9px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ForecastMap.vue